import Cookies from 'js-cookie';
import qs from 'qs';
import DefaultAxios from 'axios';
import { atob } from 'abab';
import { v4 } from 'uuid';
import md5 from 'blueimp-md5';

var Assignment = /** @class */ (function () {
    function Assignment(options) {
        if (!options.splitName) {
            throw new Error('must provide splitName');
        }
        else if (!options.hasOwnProperty('variant')) {
            throw new Error('must provide variant');
        }
        else if (!options.hasOwnProperty('isUnsynced')) {
            throw new Error('must provide isUnsynced');
        }
        this._splitName = options.splitName;
        this._variant = options.variant;
        this._context = options.context;
        this._isUnsynced = options.isUnsynced;
    }
    Assignment.fromJsonArray = function (assignmentsJson) {
        return assignmentsJson.map(function (_a) {
            var split_name = _a.split_name, variant = _a.variant, context = _a.context, unsynced = _a.unsynced;
            return new Assignment({
                context: context,
                variant: variant,
                splitName: split_name,
                isUnsynced: unsynced
            });
        });
    };
    Assignment.prototype.getSplitName = function () {
        return this._splitName;
    };
    Assignment.prototype.getVariant = function () {
        return this._variant;
    };
    Assignment.prototype.setVariant = function (variant) {
        this._variant = variant;
    };
    Assignment.prototype.getContext = function () {
        return this._context;
    };
    Assignment.prototype.setContext = function (context) {
        this._context = context;
    };
    Assignment.prototype.isUnsynced = function () {
        return this._isUnsynced;
    };
    Assignment.prototype.setUnsynced = function (unsynced) {
        this._isUnsynced = unsynced;
    };
    return Assignment;
}());

var ConfigParser = /** @class */ (function () {
    function ConfigParser() {
    }
    ConfigParser.prototype.getConfig = function () {
        var decodedConfig = atob(window.TT);
        if (decodedConfig)
            return JSON.parse(decodedConfig);
        throw new Error('Unable to parse configuration');
    };
    return ConfigParser;
}());

var Split = /** @class */ (function () {
    function Split(name, isFeatureGate, weighting) {
        this._name = name;
        this._isFeatureGate = isFeatureGate;
        this._weighting = weighting;
    }
    Split.prototype.getName = function () {
        return this._name;
    };
    Split.prototype.isFeatureGate = function () {
        return this._isFeatureGate;
    };
    Split.prototype.getVariants = function () {
        return Object.keys(this._weighting);
    };
    Split.prototype.getWeighting = function () {
        return this._weighting;
    };
    Split.prototype.hasVariant = function (variant) {
        return variant in this._weighting;
    };
    return Split;
}());

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var SplitRegistry = /** @class */ (function () {
    function SplitRegistry(splitArray) {
        this._splitArray = splitArray || [];
        this._loaded = splitArray !== null;
    }
    SplitRegistry.prototype.getSplit = function (splitName) {
        return this.getSplits()[splitName];
    };
    SplitRegistry.prototype.isLoaded = function () {
        return this._loaded;
    };
    SplitRegistry.prototype.asV1Hash = function () {
        var v1Hash = {};
        for (var splitName in this.getSplits()) {
            var split = this.getSplits()[splitName];
            v1Hash[splitName] = split.getWeighting();
        }
        return v1Hash;
    };
    SplitRegistry.prototype.getSplits = function () {
        if (!this._loaded) {
            return {};
        }
        if (!this._splits) {
            this._splits = this._splitArray.reduce(function (result, split) {
                var _a;
                return (__assign(__assign({}, result), (_a = {}, _a[split.getName()] = split, _a)));
            }, {});
        }
        return this._splits;
    };
    return SplitRegistry;
}());

var DEFAULT_VISITOR_COOKIE_NAME = 'tt_visitor_id';
var config = null;
var assignments = null;
var registry = null;
var getConfig = function () {
    if (!config) {
        var parser = new ConfigParser();
        config = parser.getConfig();
    }
    return config;
};
var TestTrackConfig = {
    _clear: function () {
        config = null;
    },
    getUrl: function () {
        return getConfig().url;
    },
    getCookieDomain: function () {
        return getConfig().cookieDomain;
    },
    getCookieName: function () {
        return getConfig().cookieName || DEFAULT_VISITOR_COOKIE_NAME;
    },
    getExperienceSamplingWeight: function () {
        return getConfig().experienceSamplingWeight;
    },
    getSplitRegistry: function () {
        var rawRegistry = getConfig().splits;
        if (!rawRegistry) {
            return new SplitRegistry(null);
        }
        if (!registry) {
            var splits = Object.keys(rawRegistry).map(function (splitName) {
                var rawSplit = rawRegistry[splitName];
                return new Split(splitName, rawSplit['feature_gate'], rawSplit['weights']);
            });
            registry = new SplitRegistry(splits);
        }
        return registry;
    },
    getAssignments: function () {
        var rawAssignments = getConfig().assignments;
        if (!rawAssignments) {
            return null;
        }
        if (!assignments) {
            assignments = [];
            for (var splitName in rawAssignments) {
                assignments.push(new Assignment({
                    splitName: splitName,
                    variant: rawAssignments[splitName],
                    isUnsynced: false
                }));
            }
        }
        return assignments;
    }
};

var defaultAxios = DefaultAxios.create({
    baseURL: "".concat(TestTrackConfig.getUrl(), "/api"),
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
});

var AssignmentOverride = /** @class */ (function () {
    function AssignmentOverride(options) {
        this._visitor = options.visitor;
        this._assignment = options.assignment;
        this._username = options.username;
        this._password = options.password;
        if (!this._visitor) {
            throw new Error('must provide visitor');
        }
        else if (!this._assignment) {
            throw new Error('must provide assignment');
        }
        else if (!this._username) {
            throw new Error('must provide username');
        }
        else if (!this._password) {
            throw new Error('must provide password');
        }
    }
    AssignmentOverride.prototype.persistAssignment = function () {
        var _this = this;
        return defaultAxios
            .post('/v1/assignment_override', qs.stringify({
            visitor_id: this._visitor.getId(),
            split_name: this._assignment.getSplitName(),
            variant: this._assignment.getVariant(),
            context: this._assignment.getContext(),
            mixpanel_result: 'success' // we don't want to track overrides
        }), {
            auth: {
                username: this._username,
                password: this._password
            }
        })
            .catch(function (error) {
            if (error.response) {
                var _a = error.response, status_1 = _a.status, statusText = _a.statusText, data = _a.data;
                _this._visitor.logError("test_track persistAssignment response error: ".concat(status_1, ", ").concat(statusText, ", ").concat(data));
            }
            else {
                _this._visitor.logError("test_track persistAssignment other error: ".concat(error));
            }
        });
    };
    return AssignmentOverride;
}());

var ABConfiguration = /** @class */ (function () {
    function ABConfiguration(options) {
        if (!options.splitName) {
            throw new Error('must provide splitName');
        }
        else if (!options.hasOwnProperty('trueVariant')) {
            throw new Error('must provide trueVariant');
        }
        else if (!options.visitor) {
            throw new Error('must provide visitor');
        }
        this._splitName = options.splitName;
        this._trueVariant = options.trueVariant;
        this._visitor = options.visitor;
        this._splitRegistry = TestTrackConfig.getSplitRegistry();
    }
    ABConfiguration.prototype.getVariants = function () {
        var splitVariants = this._getSplitVariants();
        if (splitVariants && splitVariants.length > 2) {
            this._visitor.logError('A/B for ' + this._splitName + ' configures split with more than 2 variants');
        }
        return {
            true: this._getTrueVariant(),
            false: this._getFalseVariant()
        };
    };
    ABConfiguration.prototype._getTrueVariant = function () {
        return this._trueVariant || 'true';
    };
    ABConfiguration.prototype._getFalseVariant = function () {
        var nonTrueVariants = this._getNonTrueVariants();
        return Array.isArray(nonTrueVariants) && nonTrueVariants.length !== 0 ? nonTrueVariants.sort()[0] : 'false';
    };
    ABConfiguration.prototype._getNonTrueVariants = function () {
        var splitVariants = this._getSplitVariants();
        if (splitVariants) {
            var trueVariant = this._getTrueVariant();
            var trueVariantIndex = splitVariants.indexOf(trueVariant.toString());
            if (trueVariantIndex !== -1) {
                splitVariants.splice(trueVariantIndex, 1); // remove the true variant
            }
            return splitVariants;
        }
        else {
            return null;
        }
    };
    ABConfiguration.prototype._getSplit = function () {
        return this._splitRegistry.getSplit(this._splitName);
    };
    ABConfiguration.prototype._getSplitVariants = function () {
        return this._getSplit() && this._getSplit().getVariants();
    };
    return ABConfiguration;
}());

var AssignmentNotification = /** @class */ (function () {
    function AssignmentNotification(_a) {
        var visitor = _a.visitor, assignment = _a.assignment;
        this._visitor = visitor;
        this._assignment = assignment;
        if (!this._visitor) {
            throw new Error('must provide visitor');
        }
        else if (!this._assignment) {
            throw new Error('must provide assignment');
        }
    }
    AssignmentNotification.prototype.send = function () {
        // FIXME: The current implementation of this requires 2 HTTP requests
        // to guarantee that the server is notified of the assignment. By decoupling
        // the assignment notification from the analytics write success we can
        // bring this down to 1 HTTP request
        var _this = this;
        var firstPersist = this._persistAssignment();
        var secondPersist = new Promise(function (resolve) {
            _this._visitor.analytics.trackAssignment(_this._visitor.getId(), _this._assignment, function (success) {
                return _this._persistAssignment(success ? 'success' : 'failure').then(resolve);
            });
        });
        return Promise.all([firstPersist, secondPersist]);
    };
    AssignmentNotification.prototype._persistAssignment = function (trackResult) {
        var _this = this;
        return defaultAxios
            .post('/v1/assignment_event', qs.stringify({
            visitor_id: this._visitor.getId(),
            split_name: this._assignment.getSplitName(),
            context: this._assignment.getContext(),
            mixpanel_result: trackResult
        }))
            .catch(function (error) {
            if (error.response) {
                var _a = error.response, status_1 = _a.status, statusText = _a.statusText, data = _a.data;
                _this._visitor.logError("test_track persistAssignment response error: ".concat(status_1, ", ").concat(statusText, ", ").concat(data));
            }
            else {
                _this._visitor.logError("test_track persistAssignment other error: ".concat(error));
            }
        });
    };
    return AssignmentNotification;
}());

var Identifier = /** @class */ (function () {
    function Identifier(options) {
        this.visitorId = options.visitorId;
        this.identifierType = options.identifierType;
        this.value = options.value;
        if (!this.visitorId) {
            throw new Error('must provide visitorId');
        }
        else if (!this.identifierType) {
            throw new Error('must provide identifierType');
        }
        else if (!this.value) {
            throw new Error('must provide value');
        }
    }
    Identifier.prototype.save = function () {
        return defaultAxios
            .post('/v1/identifier', qs.stringify({
            identifier_type: this.identifierType,
            value: this.value,
            visitor_id: this.visitorId
        }))
            .then(function (_a) {
            var data = _a.data;
            return new Visitor({
                id: data.visitor.id,
                assignments: Assignment.fromJsonArray(data.visitor.assignments)
            });
        });
    };
    return Identifier;
}());

var MixpanelAnalytics = /** @class */ (function () {
    function MixpanelAnalytics() {
    }
    MixpanelAnalytics.prototype.trackAssignment = function (visitorId, assignment, callback) {
        var assignmentProperties = {
            TTVisitorID: visitorId,
            SplitName: assignment.getSplitName(),
            SplitVariant: assignment.getVariant(),
            SplitContext: assignment.getContext()
        };
        if (window.mixpanel) {
            window.mixpanel.track('SplitAssigned', assignmentProperties, callback);
        }
    };
    MixpanelAnalytics.prototype.identify = function (visitorId) {
        if (window.mixpanel) {
            window.mixpanel.identify(visitorId);
        }
    };
    MixpanelAnalytics.prototype.alias = function (visitorId) {
        if (window.mixpanel) {
            window.mixpanel.alias(visitorId);
        }
    };
    return MixpanelAnalytics;
}());

var VariantCalculator = /** @class */ (function () {
    function VariantCalculator(options) {
        this.visitor = options.visitor;
        this.splitName = options.splitName;
        if (!this.visitor) {
            throw new Error('must provide visitor');
        }
        else if (!this.splitName) {
            throw new Error('must provide splitName');
        }
    }
    VariantCalculator.prototype.getVariant = function () {
        if (!TestTrackConfig.getSplitRegistry().isLoaded()) {
            return null;
        }
        var bucketCeiling = 0;
        var assignmentBucket = this.getAssignmentBucket();
        var weighting = this.getWeighting();
        var sortedVariants = this.getSortedVariants();
        for (var i = 0; i < sortedVariants.length; i++) {
            var variant = sortedVariants[i];
            bucketCeiling += weighting[variant];
            if (bucketCeiling > assignmentBucket) {
                return variant;
            }
        }
        throw new Error('Assignment bucket out of range. ' +
            assignmentBucket +
            ' unmatched in ' +
            this.splitName +
            ': ' +
            JSON.stringify(weighting));
    };
    VariantCalculator.prototype.getSplitVisitorHash = function () {
        return md5(this.splitName + this.visitor.getId());
    };
    VariantCalculator.prototype.getHashFixnum = function () {
        return parseInt(this.getSplitVisitorHash().substr(0, 8), 16);
    };
    VariantCalculator.prototype.getAssignmentBucket = function () {
        return this.getHashFixnum() % 100;
    };
    VariantCalculator.prototype.getSortedVariants = function () {
        return this.getVariants().sort();
    };
    VariantCalculator.prototype.getVariants = function () {
        return Object.getOwnPropertyNames(this.getWeighting());
    };
    VariantCalculator.prototype.getWeighting = function () {
        var split = TestTrackConfig.getSplitRegistry().getSplit(this.splitName);
        if (!split) {
            var message = 'Unknown split: "' + this.splitName + '"';
            this.visitor.logError(message);
            throw new Error(message);
        }
        return split.getWeighting();
    };
    return VariantCalculator;
}());

var VaryDSL = /** @class */ (function () {
    function VaryDSL(options) {
        if (!options.assignment) {
            throw new Error('must provide assignment');
        }
        else if (!options.visitor) {
            throw new Error('must provide visitor');
        }
        this._assignment = options.assignment;
        this._visitor = options.visitor;
        this._splitRegistry = TestTrackConfig.getSplitRegistry();
        this._variantHandlers = {};
    }
    VaryDSL.prototype.when = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var handler = typeof args[args.length - 1] === 'function' ? args.pop() : null;
        if (args.length === 0) {
            throw new Error('must provide at least one variant');
        }
        args.forEach(function (variant) {
            if (typeof variant === 'string') {
                _this._assignHandlerToVariant(variant, handler);
            }
        });
    };
    VaryDSL.prototype.default = function (variant, handler) {
        if (this._defaultVariant) {
            throw new Error('must provide exactly one `default`');
        }
        this._defaultVariant = this._assignHandlerToVariant(variant, handler);
    };
    VaryDSL.prototype.run = function () {
        this._validate();
        var defaultVariant = this.getDefaultVariant();
        if (typeof defaultVariant === 'undefined') {
            throw new Error('must provide exactly one `default`');
        }
        var chosenHandler = this._variantHandlers[defaultVariant];
        var assignedVariant = this._assignment.getVariant();
        if (assignedVariant && this._variantHandlers[assignedVariant]) {
            chosenHandler = this._variantHandlers[assignedVariant];
        }
        else {
            this._defaulted = true;
        }
        chosenHandler();
    };
    VaryDSL.prototype.isDefaulted = function () {
        return this._defaulted || false;
    };
    VaryDSL.prototype.getDefaultVariant = function () {
        return this._defaultVariant;
    };
    VaryDSL.prototype._assignHandlerToVariant = function (variant, handler) {
        if (typeof handler !== 'function') {
            throw new Error('must provide handler for ' + variant);
        }
        variant = variant.toString();
        if (this._getSplit() && !this._getSplit().hasVariant(variant)) {
            this._visitor.logError('configures unknown variant ' + variant);
        }
        this._variantHandlers[variant] = handler;
        return variant;
    };
    VaryDSL.prototype._validate = function () {
        if (!this.getDefaultVariant()) {
            throw new Error('must provide exactly one `default`');
        }
        else if (this._getVariants().length < 2) {
            throw new Error('must provide at least one `when`');
        }
        else if (!this._getSplit()) {
            return;
        }
        var missingVariants = this._getMissingVariants();
        if (missingVariants.length > 0) {
            var missingVariantSentence = missingVariants.join(', ').replace(/, (.+)$/, ' and $1');
            this._visitor.logError('does not configure variants ' + missingVariantSentence);
        }
    };
    VaryDSL.prototype._getSplit = function () {
        return this._splitRegistry.getSplit(this._assignment.getSplitName());
    };
    VaryDSL.prototype._getVariants = function () {
        return Object.getOwnPropertyNames(this._variantHandlers);
    };
    VaryDSL.prototype._getMissingVariants = function () {
        var variants = this._getVariants();
        var split = this._getSplit();
        var splitVariants = split.getVariants();
        return splitVariants.filter(function (variant) { return !variants.includes(variant); });
    };
    return VaryDSL;
}());

var Visitor = /** @class */ (function () {
    function Visitor(_a) {
        var id = _a.id, assignments = _a.assignments, ttOffline = _a.ttOffline;
        this._id = id;
        this._assignments = assignments;
        this._ttOffline = ttOffline;
        if (!this._id) {
            throw new Error('must provide id');
        }
        else if (!this._assignments) {
            throw new Error('must provide assignments');
        }
        this._errorLogger = function (errorMessage) {
            window.console.error(errorMessage);
        };
        this.analytics = new MixpanelAnalytics();
    }
    Visitor.loadVisitor = function (visitorId) {
        if (visitorId) {
            var assignments = TestTrackConfig.getAssignments();
            if (assignments) {
                return Promise.resolve(new Visitor({
                    id: visitorId,
                    assignments: assignments,
                    ttOffline: false
                }));
            }
            else {
                return defaultAxios
                    .get('/v1/visitors/' + visitorId, { timeout: 5000 })
                    .then(function (_a) {
                    var data = _a.data;
                    return new Visitor({
                        id: data.id,
                        assignments: Assignment.fromJsonArray(data.assignments),
                        ttOffline: false
                    });
                })
                    .catch(function () {
                    return new Visitor({
                        id: visitorId,
                        assignments: [],
                        ttOffline: true
                    });
                });
            }
        }
        else {
            return Promise.resolve(new Visitor({
                id: v4(),
                assignments: [],
                ttOffline: false
            }));
        }
    };
    Visitor.prototype.getId = function () {
        return this._id;
    };
    Visitor.prototype.getAssignmentRegistry = function () {
        if (!this._assignmentRegistry) {
            this._assignmentRegistry = this._assignments.reduce(function (registry, assignment) {
                var _a;
                return __assign(__assign({}, registry), (_a = {}, _a[assignment.getSplitName()] = assignment, _a));
            }, {});
        }
        return this._assignmentRegistry;
    };
    Visitor.prototype.vary = function (splitName, options) {
        if (typeof options.variants !== 'object') {
            throw new Error('must provide variants object to `vary` for ' + splitName);
        }
        else if (!options.context) {
            throw new Error('must provide context to `vary` for ' + splitName);
        }
        else if (!options.defaultVariant && options.defaultVariant !== false) {
            throw new Error('must provide defaultVariant to `vary` for ' + splitName);
        }
        var defaultVariant = options.defaultVariant.toString();
        var variants = options.variants, context = options.context;
        if (!variants.hasOwnProperty(defaultVariant)) {
            throw new Error('defaultVariant: ' + defaultVariant + ' must be represented in variants object');
        }
        var assignment = this._getAssignmentFor(splitName, context);
        var vary = new VaryDSL({
            assignment: assignment,
            visitor: this
        });
        for (var variant in variants) {
            if (variants.hasOwnProperty(variant)) {
                if (variant === defaultVariant) {
                    vary.default(variant, variants[variant]);
                }
                else {
                    vary.when(variant, variants[variant]);
                }
            }
        }
        vary.run();
        if (vary.isDefaulted()) {
            assignment.setVariant(vary.getDefaultVariant());
            assignment.setUnsynced(true);
            assignment.setContext(context);
        }
        this.notifyUnsyncedAssignments();
    };
    Visitor.prototype.ab = function (splitName, options) {
        var abConfiguration = new ABConfiguration({
            splitName: splitName,
            trueVariant: options.trueVariant,
            visitor: this
        });
        var variants = abConfiguration.getVariants();
        var variantConfiguration = {};
        variantConfiguration[variants.true.toString()] = function () {
            options.callback(true);
        };
        variantConfiguration[variants.false.toString()] = function () {
            options.callback(false);
        };
        this.vary(splitName, {
            context: options.context,
            variants: variantConfiguration,
            defaultVariant: variants.false
        });
    };
    Visitor.prototype.setErrorLogger = function (errorLogger) {
        if (typeof errorLogger !== 'function') {
            throw new Error('must provide function for errorLogger');
        }
        this._errorLogger = errorLogger;
    };
    Visitor.prototype.logError = function (errorMessage) {
        this._errorLogger.call(null, errorMessage); // call with null context to ensure we don't leak the visitor object to the outside world
    };
    Visitor.prototype.linkIdentifier = function (identifierType, value) {
        var _this = this;
        var identifier = new Identifier({
            identifierType: identifierType,
            value: value,
            visitorId: this.getId()
        });
        return identifier.save().then(function (otherVisitor) {
            _this._merge(otherVisitor);
            _this.notifyUnsyncedAssignments();
        });
    };
    Visitor.prototype.setAnalytics = function (analytics) {
        if (typeof analytics !== 'object') {
            throw new Error('must provide object for setAnalytics');
        }
        else {
            this.analytics = analytics;
        }
    };
    Visitor.prototype.notifyUnsyncedAssignments = function () {
        this._getUnsyncedAssignments().forEach(this._notify.bind(this));
    };
    Visitor.prototype._getUnsyncedAssignments = function () {
        var registry = this.getAssignmentRegistry();
        return Object.keys(registry).reduce(function (result, assignmentName) {
            var assignment = registry[assignmentName];
            if (assignment.isUnsynced()) {
                result.push(assignment);
            }
            return result;
        }, []);
    };
    Visitor.prototype._merge = function (otherVisitor) {
        var assignmentRegistry = this.getAssignmentRegistry();
        var otherAssignmentRegistry = otherVisitor.getAssignmentRegistry();
        this._id = otherVisitor.getId();
        Object.assign(assignmentRegistry, otherAssignmentRegistry);
    };
    Visitor.prototype._getAssignmentFor = function (splitName, context) {
        return this.getAssignmentRegistry()[splitName] || this._generateAssignmentFor(splitName, context);
    };
    Visitor.prototype._generateAssignmentFor = function (splitName, context) {
        var variant = new VariantCalculator({
            visitor: this,
            splitName: splitName
        }).getVariant();
        if (!variant) {
            this._ttOffline = true;
        }
        var assignment = new Assignment({
            splitName: splitName,
            variant: variant,
            context: context,
            isUnsynced: true
        });
        this._assignments.push(assignment);
        // reset derived datastores to trigger rebuilding
        this._assignmentRegistry = null;
        return assignment;
    };
    Visitor.prototype._notify = function (assignment) {
        try {
            if (this._ttOffline) {
                return;
            }
            var notification = new AssignmentNotification({
                visitor: this,
                assignment: assignment
            });
            notification.send();
            assignment.setUnsynced(false);
        }
        catch (e) {
            this.logError('test_track notify error: ' + e);
        }
    };
    return Visitor;
}());

var loaded = null;
var Session = /** @class */ (function () {
    function Session() {
        this._visitorLoaded = new Promise(function (resolve) { return (loaded = resolve); });
    }
    Session.prototype.initialize = function (options) {
        var visitorId = Cookies.get(TestTrackConfig.getCookieName());
        Visitor.loadVisitor(visitorId).then(function (visitor) {
            if (options && options.analytics) {
                visitor.setAnalytics(options.analytics);
            }
            if (options && options.errorLogger) {
                visitor.setErrorLogger(options.errorLogger);
            }
            if (options && typeof options.onVisitorLoaded === 'function') {
                options.onVisitorLoaded.call(null, visitor);
            }
            visitor.notifyUnsyncedAssignments();
            if (loaded) {
                loaded(visitor);
            }
        });
        this._setCookie();
        return this._visitorLoaded;
    };
    Session.prototype.vary = function (splitName, options) {
        return this._visitorLoaded.then(function (visitor) {
            visitor.vary(splitName, options);
        });
    };
    Session.prototype.ab = function (splitName, options) {
        return this._visitorLoaded.then(function (visitor) {
            visitor.ab(splitName, options);
        });
    };
    Session.prototype.logIn = function (identifierType, value) {
        var _this = this;
        return this._visitorLoaded.then(function (visitor) {
            return visitor.linkIdentifier(identifierType, value).then(function () {
                _this._setCookie();
                visitor.analytics.identify(visitor.getId());
            });
        });
    };
    Session.prototype.signUp = function (identifierType, value) {
        var _this = this;
        return this._visitorLoaded.then(function (visitor) {
            return visitor.linkIdentifier(identifierType, value).then(function () {
                _this._setCookie();
                visitor.analytics.alias(visitor.getId());
            });
        });
    };
    Session.prototype._setCookie = function () {
        return this._visitorLoaded.then(function (visitor) {
            Cookies.set(TestTrackConfig.getCookieName(), visitor.getId(), {
                expires: 365,
                path: '/',
                domain: TestTrackConfig.getCookieDomain()
            });
        });
    };
    Session.prototype.getPublicAPI = function () {
        var _this = this;
        return {
            vary: this.vary.bind(this),
            ab: this.ab.bind(this),
            logIn: this.logIn.bind(this),
            signUp: this.signUp.bind(this),
            initialize: this.initialize.bind(this),
            _crx: {
                loadInfo: function () {
                    return _this._visitorLoaded.then(function (visitor) {
                        var assignmentRegistry = {};
                        for (var splitName in visitor.getAssignmentRegistry()) {
                            assignmentRegistry[splitName] = visitor.getAssignmentRegistry()[splitName].getVariant();
                        }
                        return {
                            visitorId: visitor.getId(),
                            splitRegistry: TestTrackConfig.getSplitRegistry().asV1Hash(),
                            assignmentRegistry: assignmentRegistry
                        };
                    });
                },
                persistAssignment: function (splitName, variant, username, password) {
                    return _this._visitorLoaded.then(function (visitor) {
                        return new AssignmentOverride({
                            visitor: visitor,
                            username: username,
                            password: password,
                            assignment: new Assignment({
                                splitName: splitName,
                                variant: variant,
                                context: 'chrome_extension',
                                isUnsynced: true
                            })
                        }).persistAssignment();
                    });
                }
            }
        };
    };
    return Session;
}());

var TestTrack = new Session().getPublicAPI();
var notifyListener = function () {
    window.dispatchEvent(new CustomEvent('tt:lib:loaded', {
        detail: {
            TestTrack: TestTrack
        }
    }));
};
var loadTestTrack = function () {
    // Add class to body of page after body is loaded to enable chrome extension support
    document.body.classList.add('_tt');
    try {
        window.dispatchEvent(new CustomEvent('tt:class:added'));
    }
    catch (e) {
        // ignore
    }
};
try {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', loadTestTrack);
    }
    else {
        loadTestTrack();
    }
    // **** The order of these two lines is important, they support 2 different cases:
    // in the case where there is already code listening for 'tt:lib:loaded', trigger it immediately
    // in the case where there is not yet code listening for 'tt:lib:loaded', listen for 'tt:listener:ready' and then trigger 'tt:lib:loaded'
    notifyListener();
    window.addEventListener('tt:listener:ready', notifyListener);
}
catch (e) {
    // ignore
}

export { TestTrack as default };
